export const GET_CURRENT_QUARTERLY_PAY_DISPLAY_OBJ =
  "GET_CURRENT_QUARTERLY_PAY_DISPLAY_OBJ";
export const GET_CURRENT_QUARTERLY_PAY_DETAIL_OBJ =
  "GET_CURRENT_QUARTERLY_PAY_DETAIL_OBJ";
export const GET_PLAN_TYPE_DATA = "GET_PLAN_TYPE_DATA";
export const GET_REBATE_PROGRAM = "GET_REBATE_PROGRAM";
export const GET_ERROR_MSG_QUARTERLY_PAYMENT =
  "GET_ERROR_MSG_QUARTERLY_PAYMENT";
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE =
"GET_DRAMS_INVOICE_START_QUARTER_VALUE"; 
export const GET_EARLIEST_QTR_DRUG_VALUE = "GET_EARLIEST_QTR_DRUG_VALUE";
export const DISPLAY_QUARTER_RANGE = "DISPLAY_QUARTER_RANGE";
export const DISPLAY_QUARTER_OBJ = "DISPLAY_QUARTER_OBJ";
export const GET_BALANCE_THRESHOLD_VALUE = "GET_BALANCE_THRESHOLD_VALUE"
export const GET_MANUFACTURERS_DATA_LIST = "GET_MANUFACTURERS_DATA_LIST";
export const GET_QUARTERLY_PAYMENT_DATA = "GET_QUARTERLY_PAYMENT_DATA";
export const QUARTERLY_PAYMENT_DETAILS_CORRESPONDENCE =
  "QUARTERLY_PAYMENT_DETAILS_CORRESPONDENCE";
export const DISPLAY_QUARTERLY_PAYMENT_DETAILS =
  "DISPLAY_QUARTERLY_PAYMENT_DETAILS";
export const CLEAR_QTRLY_PAY_TAB = "CLEAR_QTRLY_PAY_TAB";
